import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import SignupPage from "./pages/SignupPage";
import LoginPage from "./pages/LoginPage";
import PostJob from "./components/Jobs/PostJob";
import Home from "./components/Navbar/Home";
import JobDetailsPage from "./pages/JobDetailsPage";
import PageTitle from "./components/PageTitle";
import InternshipPage from "./pages/InternshipPage";
import NotFound from "./components/NotFound";
import AboutPage from "./pages/AboutPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import AssessmentPages from "./pages/AssessmentPages";
import HackathonPage from "./pages/HackathonPage";
import OAuthCallback from "./pages/OAuthCallback";
import AddHackathon from "./components/Hackathons/AddHackathon";
import HackathonDetailsPage from "./pages/HackathonDetailsPage";
import WriteBlog from "./components/Blogs/WriteBlog";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";

const root = ReactDOM.createRoot(document.getElementById("root"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: (
          <>
            <PageTitle title="JobIntelPro" />
            <Home />
          </>
        ),
      },
      {
        path: "/job/:id",
        element: (
          <>
            <JobDetailsPage />
          </>
        ),
      },
      {
        path: "/signup",
        element: (
          <>
            <SignupPage />,
            <PageTitle title="Signup | JobIntelPro" />
          </>
        ),
      },
      {
        path: "/login",
        element: (
          <>
            <PageTitle title="Login | JobIntelPro" />
            <LoginPage />
          </>
        ),
      },
      {
        path: "/postjob",
        element: (
          <>
            <PageTitle title="Post Job | JobIntelPro" />
            <ProtectedRoute>
              <PostJob />
            </ProtectedRoute>
          </>
        ),
      },
      {
        path: "/internships",
        element: (
          <>
            <PageTitle title="Internship | JobIntelPro" />
            <InternshipPage />
          </>
        ),
      },
      {
        path: "/about",
        element: (
          <>
            <PageTitle title="AboutUs | JobIntelPro" />
            <AboutPage />
          </>
        ),
      },
      {
        path: "/privacy-policy",
        element: (
          <>
            <PageTitle title="Privacy Policy | JobIntelPro" />
            <PrivacyPolicyPage />
          </>
        ),
      },
      {
        path: "/terms-of-service",
        element: (
          <>
            <PageTitle title="Terms of Service | JobIntelPro" />
            <TermsOfServicePage />
          </>
        ),
      },
      {
        path: "/assessments",
        element: (
          <>
            <PageTitle title="Assessment | JobIntelPro" />
            <ProtectedRoute>
              <AssessmentPages />
            </ProtectedRoute>
          </>
        ),
      },
      {
        path: "/hackathons",
        element: (
          <>
            <PageTitle title="Hackathons | JobIntelPro" />

            <HackathonPage />
          </>
        ),
      },
      {
        path: "/hackathons/:id",
        element: (
          <>
            <HackathonDetailsPage />
          </>
        ),
      },
      {
        path: "/add-hackathon",
        element: (
          <>
            <PageTitle title="Add Hackathon | JobIntelPro" />
            <ProtectedRoute>
              <AddHackathon />
            </ProtectedRoute>
          </>
        ),
      },
      {
        path: "/blog",
        element: (
          <>
            <PageTitle title="Blogs | JobIntelPro" />

            <BlogPage />
          </>
        ),
      },
      {
        path: "/blog/:id",
        element: (
          <>
            <BlogDetailsPage />
          </>
        ),
      },
      {
        path: "/write-blog",
        element: (
          <>
            <PageTitle title="Write Blog | JobIntelPro" />
            <ProtectedRoute>
              <WriteBlog />
            </ProtectedRoute>
          </>
        ),
      },
      {
        path: "/auth/callback",
        element: <OAuthCallback />,
      },
      {
        path: "*",
        element: (
          <>
            <PageTitle title="404: Not Found" />
            <NotFound />
          </>
        ),
      },
    ],
  },
]);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
